module.exports = __webpack_public_path__ + "fonts/Lufthansa Text Bold.3fddc578.woff";